/**
 * 解决 React 页面组件生命周期问题
 * Warining: 本hook当前处于开发状态，一般情况下请不需要使用此组件
 */

import { useHistory } from '@medlinker/fundamental';
import { useEffect, useRef } from 'react';

let loaded = false;

interface Config {
  /** 挂载时触发 */
  onMount?: () => void;
  /** 卸载时触发 */
  onUnMount?: () => void;
  /** 因push事件挂载触发 */
  onPushMount?: () => void;
  /** 因pop事件挂载时触发 */
  onPopMount?: () => void;
  /** 因push事件卸载时触发 */
  onPushUnmount?: () => void;
  /** 因pop事件卸载时触发 */
  onPopUnmount?: () => void;
}

export default (config: Config) => {
  const history = useHistory();
  const action: 'PUSH' | 'POP' | 'REPLACE' = loaded ? history.action : 'PUSH';
  const configRef = useRef(config);
  const actionRef = useRef(action);

  useEffect(() => {
    configRef.current = config;
  }, [config]);

  useEffect(() => {
    loaded = true;
    const cconfig = configRef.current;

    cconfig.onMount && cconfig.onMount();

    if (action === 'POP') {
      cconfig.onPopMount && cconfig.onPopMount();
    } else {
      cconfig.onPushMount && cconfig.onPushMount();
    }

    return () => {
      if (history.action === 'POP') {
        cconfig.onPopUnmount && cconfig.onPopUnmount();
      } else {
        cconfig.onPushUnmount && cconfig.onPushUnmount();
      }
      cconfig.onUnMount && cconfig.onUnMount();
    };
    // eslint-disable-next-line
  }, []);

  return actionRef.current;
};
